import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'core/api/queryKeys';
import { humanizeApiError } from 'core/errors/mapFieldErrors';
import { useI18n } from 'core/i18n/I18nProvider';
import { companyApi } from 'features/company/company.api';
import { useCompany } from 'features/company/CompanyContext';
import { ErrorState, Skeleton } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';
import { ResultPresentation } from 'shared/components/ResultPresentation';

export function CompanyParticipantResultPage() {
  const { attemptId } = useParams();
  const { companyId } = useCompany();
  const { t } = useI18n();
  const query = useQuery({
    queryKey: queryKeys.companyParticipantResult(attemptId),
    queryFn: () => companyApi.participantResult(companyId, attemptId),
  });

  if (query.isLoading) {
    return <Skeleton rows={8} />;
  }
  if (query.isError) {
    return <ErrorState title={humanizeApiError(query.error, t)} onRetry={() => query.refetch()} retryLabel={t('actions.retry')} homeAction={false} />;
  }

  const result = query.data?.result;
  return (
    <div>
      <PageMeta titleKey="meta.companyParticipantResult" />
      <ResultPresentation result={result} sponsored showConsultationActions={false} />
    </div>
  );
}
